import { ArrowBackIos, Image } from "@mui/icons-material";
import { Box,   styled, Typography } from "@mui/material";

export const S = {
    Layout: styled(Box)<{ isCollapsed?: boolean }>(({ theme, isCollapsed }) => ({
        display: "grid",
        gridTemplateColumns: isCollapsed ? "105px auto" : "250px auto",
        height: "100vh",
    })),

    Navigation: styled(Box)<{ isCollapsed?: boolean }>(({ theme, isCollapsed }) => ({
        width: isCollapsed ? 105 : 250,
        transition: "all 0.1s cubic-bezier(0.4, 0, 0.2, 1)",
        position: "relative",
        textAlign: "center",
        paddingTop: theme.spacing(23),
        backgroundColor: theme.palette.common.white,
        boxShadow: "0px 0px 5px 0px rgba(0,0,0,0.05)",
        zIndex: 2,
        ".menu": {
            marginTop: theme.spacing(12),
        },
    })),

    Body: styled(Box)(({ theme }) => ({
        display: "grid",
        gridTemplateRows: "80px auto",
        backgroundColor: theme.palette.grey[100],
        zIndex: 1,
    })),

    Content: styled(Box)(({ theme }) => ({
        display: "flex",
        flexDirection: "column",
        backgroundColor: theme.palette.grey[100],
    })),

    Header: styled(Box)(({ theme }) => ({
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
        paddingRight: theme.spacing(10),
        paddingLeft: theme.spacing(10),
        display: "flex",
        justifyContent: "flex-end",
    })),

    Logo: styled(Box)(() => ({
        display: "flex",
        flexDirection: "row",
        alignContent: "center",
        justifyContent: "center",
    })),

    Img: styled(Image)(({ theme }) => ({
        display: "flex",
        width: theme.spacing(10),
    })),

    CloseButton: styled(Box)(() => ({
        position: "absolute",
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
        top: 15,
        right: 20,
        zIndex: 5,
    })),

    CloseButtonText: styled(Typography)((theme) => ({
        fontSize: 12,
        fontWeight: 400,
    })),

    CloseButtonIcon: styled(ArrowBackIos)<{ isCollapsed?: boolean }>(({ isCollapsed }) => ({
        width: 16,
        height: 16,
        transform: isCollapsed ? "rotate(180deg)" : "none",
    })),
};
